<div *ngIf="! showSummaryOnly()" class="jumbotron text-center mdb-color lighten-2 white-text mx-2 mb-5">
  <h2 class="card-title h2">Message</h2>
  <p>Speak to your loved ones from beyond the grave! Leave messages for people here to be passed on after you've passed on!</p>
</div>

<app-service-completion *ngIf="! showSummaryOnly()" [service]="object"></app-service-completion>

<div *ngIf="showSummaryOnly()" class="list-group list-group-flush">
  <div class="list-group-item list-group-item-action d-flex align-items-center justify-content-between">

    <div class="flex-fill">
      <div class="row align-items-center">
        <div class="col-sm-4">
          This message is for
        </div>
        <div class="col-sm-8">
          Message
        </div>
      </div>
    </div>

  </div>
</div>

<app-service-child-list [object]="object" [key]="key" [extraData]="extraData">
  <div *app-content-loader="let item" class="flex-fill">

    <div class="row align-items-center">
      <div class="col-sm-4">
        {{ item['who_is_the_message_for'] }}
      </div>
      <div class="col-sm-8">
        {{ item['your_message'] }}
      </div>
    </div>

  </div>
</app-service-child-list>
